import { StatisticsGrid, StatisticsGridDefaultValues } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

export type IAttributes = React.ComponentProps<typeof StatisticsGrid>

const StatisticsGridBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return <StatisticsGrid {...StatisticsGridDefaultValues} {...attributes} />
}

export default StatisticsGridBlock
